import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from '../../../services/rest/rest.service';
import { MoneyTalk } from './money-talk.domain';

@Injectable()
export class MoneyTalkRestService {
  constructor(private restService: RestService) {
  }

  getMoneyTalk(): Observable<MoneyTalk> {
    return this.restService.getResource('moneyTalk.getFeedData')
      .get<MoneyTalk>();
  }
}

